import { NotificationModel } from '@arpeggi/shared'
import axios from '../../../__legacy__/lib/axios'

export const markNotificationAsRead = async (id: number) => {
  const { data } = await axios.post<NotificationModel>('/api/v2/read-notifications', {
    notificationId: id
  })

  return data
}
